'use strict'
import { Util, Action } from '../config/app.js'
import { default as Component } from '../component.js'
import { currentUser, elementToggle, hasRole, getNetworkFromCreditCardNumber, getError } from '../helper.js'

class Checkout extends Component
{
	init()
	{
		this.model = App.Store.model('checkout', currentUser().id)
		this.action = App.Action.cache(this.element.getAttribute('ui-action'))
		this.element.addEventListener('change', e => this.onChange(e))
		this.element.addEventListener('keydown', e => this.onKeyDown(e))
		document.addEventListener('error', e => this.onError(e))
		document.addEventListener('action.before', e => this.onActionBefore(e))
		document.addEventListener('action.after', e => this.onActionAfter(e))
		this.paymentMethodFormToggle('WalletCard')
	}
	
	update()
	{
		if (!this.element.checkValidity())
		{
			this.updateRequired = true // Form can't be submitted yet, but should the next change
			return false
		}

		if (this.action.running)
		{
			this.updateRequired = true
			App.Store.abort('checkout')
			return false
		}

		this.updateRequired = false
		this.model.clearChanges()
		//this.model.clear()

		this.action.run(this.element)

		return true
	}

	syncFormToModel()
	{
		let formData = Util.formToObject(this.element)
		if (!formData.billingAddress?.address1)
			delete formData.billingAddress
		this.model.attributes.sync(formData)
	}

	reportValidation()
	{
		let formData = Util.formToObject(this.element)
		const validation = {
			running: !this.action.running,
			form: this.element.reportValidity(), // Form is valid
			updated: !this.updateRequired, // Checkout needs updated
			shippingAddress: formData.shippingAddress.validate == 'false', // Address doesn't need validated
			shippingMethod: (formData.hasOwnProperty('shippingMethod') && formData.shippingMethod != ''), // Shipping option selected
			stripeToken: (!hasRole('Patient') || (hasRole('Patient') && (formData.walletCard.id || formData.walletCard.token))) // Patient must have an existing or new card
		}
		validation.valid = Object.entries(validation).filter(e => e[1] == false).length == 0 // All requirements are valid
		return validation
	}

	billingAddressClear()
	{
		for (const input of this.element.querySelectorAll('[name^="billingAddress["]:not([name="billingAddress[country]"],[type=checkbox],[type=radio]),[name^="walletCard["]:not([name="walletCard[id]"],[name="walletCard[save]"])'))
		{
			console.info('billingAddressClear', input.name)
			input.value = ''
		}
	}

	paymentMethodFormToggle(paymentMethodId, force = false)
	{
		if (!paymentMethodId)
			paymentMethodId = this.element.querySelector('[name="paymentMethod[id]"]').value
		
		if (paymentMethodId == 'Payments.Payfabric' || paymentMethodId == 'Payments.Stripe')
			paymentMethodId = 'WalletCard'

		const walletCardIdCheckbox = this.element.querySelector('[name="walletCard[id]"]')
		if (paymentMethodId == 'WalletCard' && !force)
		{
			if (!walletCardIdCheckbox.value || walletCardIdCheckbox.checked)
				paymentMethodId = 'WalletCardNew'
		}
		
		walletCardIdCheckbox.checked = (paymentMethodId == 'WalletCard')
		this.element.querySelectorAll('[id^="checkoutPaymentMethod["]')
			.forEach(el => el.classList.add('hidden'))
		this.element.querySelector('[id^="checkoutPaymentMethod[' + paymentMethodId + ']"]').classList.remove('hidden')

		if (paymentMethodId == 'WalletCardNew')
		{
			this.element.querySelector('[id="paymentMethod[id][WalletCard]"]').checked = true
			elementToggle(this.element.querySelector('[id="checkoutPaymentMethod[WalletCardNew]"]'), true)
			this.element.querySelector('#checkoutShippingSameAsBilling').parentElement.parentElement.classList.remove('hidden')
		}
		else
		{
			this.element.querySelector('[id="paymentMethod[id][' + paymentMethodId + ']"]').checked = true
			elementToggle(this.element.querySelector('[id="checkoutPaymentMethod[WalletCardNew]"]'), false)

			for (const input of this.element.querySelectorAll('[name^="billingAddress["], [name^="walletCard["]:not([name="walletCard[id]"],[name="walletCard[save]"],[type=checkbox],[type=radio])'))
			{
				input.value = ''
			}

			this.element.querySelector('#checkoutShippingSameAsBilling').checked = false
			this.element.querySelector('#checkoutShippingSameAsBilling').parentElement.parentElement.classList.add('hidden')
		}

		delete this.model.attributes?.walletCard
		this.shippingAddressFormToggle()
		if (this.updateRequired)
			this.update() // Form may have been invalid due to billing address form
	}

	shippingOptionsClear()
	{
		if (this.model.relationships?.shippingOptions?.data?.length)
			this.model.relationships.shippingOptions.data = []
		this._submitOrderAfterUpdate = false
	}

	//#region Shipping Address
	shippingAddressFormToggle()
	{
		if (this.element.querySelector('#checkoutShippingSameAsBilling').checked)
			this.element.querySelectorAll('#checkoutShippingAddress > .row:not(:last-child)')
				.forEach(el => elementToggle(el, false))
		else
			this.element.querySelectorAll('#checkoutShippingAddress > .row')
				.forEach(el => elementToggle(el, true))
	}

	shippingAddressClear()
	{
		this.shippingAddressResetValidation()
		for (const input of this.element.querySelectorAll('[name^="shippingAddress["]:not([name="shippingAddress[country]"],[type=checkbox],[type=radio])'))
		{
			input.value = ''
		}
		this.model.relationships?.shippingAddress?.clear()
		this.shippingOptionsClear()
		this.element.querySelector('#checkoutShippingSameAsBilling').checked = false
		this.shippingAddressFormToggle()
	}

	shippingAddressCopyFromBilling()
	{
		let update = false

		for (const inputBilling of this.element.querySelectorAll('[name^="billingAddress["]'))
		{
			const name = inputBilling.name.replace('billing', 'shipping')
			const inputShipping = this.element.querySelector('[name="' + name + '"]')
			if (inputShipping.value != inputBilling.value)
			{
				inputShipping.value = inputBilling.value
				if (!update)
				{
					update = inputShipping.matches([
						'[name="shippingAddress[address1]"]',
						'[name="shippingAddress[city]"]',
						'[name="shippingAddress[stateProvince]"]',
						'[name="shippingAddress[postalCode]"]'
					])
				}
			}
		}

		// Ensure stateProvince gets selected (options could have been empty pending Country change)
		const selectStateProvince = this.element.querySelector('[name="shippingAddress[stateProvince]"]')
		const billingStateProvince = this.element.querySelector('[name="billingAddress[stateProvince]"]')
		if (selectStateProvince.value != billingStateProvince.value)
		{
			selectStateProvince.setAttribute('value', billingStateProvince.value)
			this.element.querySelector('[name="shippingAddress[country]"]')
				.dispatchEvent(new Event('change'))
		}

		if (update)
		{
			this.shippingAddressResetValidation(true)
			this.update()
		}
	}

	shippingAddressSelect(id)
	{
		const model = App.Store.model('address', id)
		const suggestion = parseInt(model.suggestion) || 0
		this.element.querySelector('#checkoutShippingSameAsBilling').checked = false
		this.shippingAddressFormToggle()
		
		if (id == 'SHIPPING' && model.suggestion == -1)
		{
			// User clicked "OK" to keep existing address
			this.element.querySelector('[name="shippingAddress[validate]"]').value = 'false'
			this.model.attributes.shippingAddress.validate = 'false'
			return
		}

		this.shippingOptionsClear()
		this.shippingAddressResetValidation()

		for (let [key, value] of Object.entries(model.attributes))
		{
			const input = this.element.querySelector('[name="shippingAddress[' + key + ']"]')
			if (input)
			{
				input.value = value
				if (key == 'country')
				{
					const selectStateProvince = this.element.querySelector('[name="shippingAddress[stateProvince]"]')
					if (selectStateProvince.value != model.attributes.stateProvince)
					{
						selectStateProvince.setAttribute('value', model.attributes.stateProvince)
						input.dispatchEvent(new Event('change'))
					}
				}
			}
		}

		this.update()
	}

	shippingAddressResetValidation(sameAsBillingChecked = false)
	{
		this.element.querySelector('#checkoutShippingSameAsBilling').checked = sameAsBillingChecked
		this.element.querySelector('[name="shippingAddress[validate]"]').value = true
		delete this.model.relationships.shippingAddress // Ensure shipping option alerts assume no shipping address until validated
		
		if (!this.model.attributes.shippingAddress)
			this.model.attributes.shippingAddress = {}
		this.model.attributes.shippingAddress.validate = true
	}
	//#endregion Shipping Address

	//#region Wallet Card
	walletCardSelect(id)
	{
		const model = App.Store.model('walletcard', id)
		const input = this.element.querySelector('[name="walletCard[id]"]')
		const span = this.element.querySelector('[name="walletCard[id]"] ~ span')

		span.innerHTML = (model.attributes.nickname ? '<strong>' + model.attributes.nickname + '</strong><br />' : '')
			+ '<i class="fa fa-cc-' + model.attributes.network.toLowerCase() + '"></i> '
			+ model.attributes.network + ' <tt>&bull;&bull;&bull;&bull;' + model.attributes.lastFour + '</tt><br />'
			+ '<em>Expires ' + model.attributes.expirationMonth + '/' + model.attributes.expirationYear + '</em>'
		
		input.value = model.id

		this.paymentMethodFormToggle('WalletCard', true)
		this.update()
	}

	walletCardValidate()
	{
		let formData = Util.formToObject(this.element)
		if (formData.walletCard?.id
			|| !formData.walletCard.expirationMonth
			|| !formData.walletCard.expirationYear
		)
			return // Existing card set or expiration missing
		
		const now = new Date()
		const expDate = new Date(formData.walletCard.expirationYear, formData.walletCard.expirationMonth)

		if (now >= expDate)
		{
			this.element.querySelector('[name="walletCard[expirationMonth]"]')?.classList.add('input-validation-error')
			this.element.querySelector('[name="walletCard[expirationYear]"]')?.classList.add('input-validation-error')
			this.element.querySelector('[name="walletCard[expirationMonth]"]').focus()
			return
		}
		else
		{
			this.element.querySelector('[name="walletCard[expirationMonth]"]')?.classList.remove('input-validation-error')
			this.element.querySelector('[name="walletCard[expirationYear]"]')?.classList.remove('input-validation-error')
		}

		if (!formData.walletCard.token && hasRole('Patient') && formData.walletCard.number && formData.walletCard.cvc)
		{
			Action.reflectCssClass(this.action.name, App.cssClass.loading, { stripeToken: null })
			Stripe.card.createToken(
				{
					number: formData.walletCard.number,
					cvc: formData.walletCard.cvc,
					exp_month: formData.walletCard.expirationMonth,
					exp_year: formData.walletCard.expirationYear
				},
				(_status, response) =>
				{
					if (response.error)
					{
						Action.reflectCssClass(this.action.name, App.cssClass.fail, { stripeToken: null })
						this.element.querySelector('[name="walletCard[number]"]').focus()
						App.UI.AlertError(response.error.message)
					}
					else
					{
						Action.reflectCssClass(this.action.name, App.cssClass.success, { stripeToken: response.id })
						const inputToken = this.element.querySelector('[name="walletCard[token]"]')
						inputToken.value = response.id
						this.model.attributes.walletCard.token = response.id
					}
				})
		}
	}
	//#endregion Wallet Card

	//#region Event handlers
	onActionBefore(e)
	{
		if (e.detail.canceled)
			return

		if (e.detail.name == 'order create')
		{
			const validation = this.reportValidation()
			if (!validation.valid)
			{
				e.preventDefault()
				if (!validation.running || !validation.form)
					return

				if (this.model.shippingOptionsLastError)
				{
					App.UI.AlertError(this.model.shippingOptionsLastError)
				}
				else if (!validation.updated || !validation.shippingAddress)
				{
					this._submitOrderAfterUpdate = true
					this.update()
				}
				else if (!validation.shippingMethod)
				{
					App.Component.HandleErrors({ errors: [{ code: 'SHIPPING_OPTIONS_MISSING' }] })
				}
			}
		}
	}

	onActionAfter(e)
	{
		if (e.detail.canceled && this.updateRequired && e.detail.name == 'checkout update')
			this.update() // Update has been aborted and should retry

		if (!e.detail.success)
			this.onError(e)

		if (e.detail.canceled || !e.detail.success)
			return

		if (e.detail.name == 'addressselect modal submit')
			this.shippingAddressSelect(e.detail.data.id)
		else if (e.detail.name == 'walletcardselect modal submit')
			this.walletCardSelect(e.detail.data.id)
		else if (e.detail.name == 'checkout clear paymentMethod')
		{
			this.billingAddressClear()
			this.paymentMethodFormToggle('WalletCard')
		}
		else if (e.detail.name == 'checkout clear shippingAddress')
			this.shippingAddressClear()
		else if (e.detail.name == 'checkout update')
		{
			if (this.model.shippingOptionsLastError)
				delete this.model.shippingOptionsLastError

			const shippingAddress = App.Store.model('address', 'SHIPPING')
			this.element.querySelector('[name="shippingAddress[validate]"]').value = shippingAddress?.attributes?.validate ?? true

			if (shippingAddress?.attributes?.validate && !shippingAddress.attributes?.validation?.valid)
				App.Modal.AddressSuggestions.open(false, false, shippingAddress)

			this.syncFormToModel()

			if (this.updateRequired)
			{
				// Submit update automatically?
			}
			else if (this._submitOrderAfterUpdate)
			{
				const form = document.querySelector('form[ui-action="order create"]')
				if (form)
				{
					// Auto-submit the form
					if (this.updateRequired || (shippingAddress?.attributes?.validate && !shippingAddress.attributes?.validation?.valid))
						return // Don't auto-submit if the form needs updated or we are presenting address suggestions
					App.Action.cache('order create').run(form)
				}
			}
		}
		else if (e.detail.name == 'order create' && !e.detail.success)
		{
			this._submitOrderAfterUpdate = false // Make sure we do not auto-submit in case of an order create error
			this.update()
		}
	}

	onChange(e)
	{
		e.target.reportValidity()

		if (e.target.id == 'checkoutShippingSameAsBilling' || (this.element.querySelector('#checkoutShippingSameAsBilling').checked && e.target.matches('[name^="billingAddress["]')))
		{
			this.shippingAddressCopyFromBilling()
			this.shippingAddressFormToggle()
		}

		if (e.target.name == 'paymentMethod[id]')
			this.paymentMethodFormToggle(e.target.value)

		if (e.target.matches([
			'[name="walletCard[number]"]',
			'[name="walletCard[expirationMonth]"]',
			'[name="walletCard[expirationYear]"]',
			'[name="walletCard[cvc]"]'
		]))
		{
			if (e.target.matches('[name="walletCard[number]"]'))
				this.element.querySelector('[name="walletCard[network]"]').value = getNetworkFromCreditCardNumber(e.target.value)

			this.walletCardValidate()
		}

		const update = e.target.matches([
			'[name="paymentMethod[id]"]',
			'[name="shippingMethod"]',
			'[name="shippingAddress[address1]"]',
			'[name="shippingAddress[city]"]',
			'[name="shippingAddress[stateProvince]"]',
			'[name="shippingAddress[postalCode]"]'
		]) || this.updateRequired
		let updated = false

		if (update)
			updated = this.update()

		if (!updated)
			this.syncFormToModel()
	}

	onKeyDown(e)
	{
		if (e.target.matches([
			'[name="shippingAddress[address1]"]',
			'[name="shippingAddress[city]"]',
			'[name="shippingAddress[stateProvince]"]',
			'[name="shippingAddress[postalCode]"]'
		]))
		{
			App.Store.abort('checkout')
			this.shippingAddressResetValidation()
			this.shippingOptionsClear()
		}
	}

	onError(e)
	{
		if (e?.detail?.canceled)
			return

		const error = getError(e)
		const errorCode = error?.code

		switch (errorCode)
		{
			case 'shipping_options_calculation_failed':
				e?.preventDefault()
				this.shippingOptionsClear()
				this.model.shippingOptionsLastError = error?.message
				break
			case 'cart_item_backorders_removed':
			case 'cart_empty':
				delete this.model.relationships.cart
				App.Store.model('cartitem').clear()
				App.Router.navigate('/cart')
				break
			case 'coupon_invalid':
			case 'coupon_allowed_amount_exceeded':
				delete this.model.attributes.couponCode
			case 'order_price_change':
				this.update()
				break
		}
	}
	//#endregion Event handlers
}

export default Checkout
